'use client';

import { useSessionRotation } from './useSessionRotation';

/**
 * Point de montage unique de la rotation proactive de session (cf. `useSessionRotation`).
 * Ne rend rien : monté dans le layout racine pour couvrir toute navigation, y compris les
 * pages purement RSC qui n'appellent jamais l'API.
 */
export function SessionRotation(): null {
    useSessionRotation();
    return null;
}
